import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './style.css';

import ContactUsSection from '../../Components/ContactUsSection';

export default function ContactUs() {
  const location = useLocation();
  
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='contact-us-page'>
      <Helmet>
        <title>Starlife: Contact Us</title>
        <meta
          name='description'
          content='Get in touch with Starlife Group for inquiries, investments, or real estate services. We’re here to assist you with all your needs.'
        />
        <meta
          name='keywords'
          content='Contact Starlife Group, Real estate inquiries, Luxury property investments, Get in touch with Starlife Group, Real estate services Miami'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>

      <ContactUsSection />
    </div>
  );
}
